import { useSyncExternalStore } from "react";
import type { ExplainerStatus } from "./eligibility.ts";
import { useTextKitsExplainerEnabled } from "./flag.ts";

type PhotosAnchor = {
    element: HTMLElement;
    listingId: string;
    status: ExplainerStatus;
};

let current: PhotosAnchor | null = null;
const listeners = new Set<() => void>();

function publish(next: PhotosAnchor | null) {
    current = next;
    for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function useTextKitsExplainerAnchor() {
    return useSyncExternalStore(
        subscribe,
        () => current,
        () => null,
    );
}

export function TextKitsExplainerAnchor({
    listingId,
    status,
}: {
    listingId: string;
    status: ExplainerStatus | "unavailable";
}) {
    const enabled = useTextKitsExplainerEnabled();
    if (!enabled || status === "unavailable") return null;
    return (
        <span
            ref={(element) => {
                if (!element) return;
                const anchor = { element, listingId, status };
                publish(anchor);
                return () => {
                    if (current === anchor) publish(null);
                };
            }}
            aria-hidden
            className="pointer-events-none absolute bottom-0 left-0 size-0"
        />
    );
}
